import { IEnrollment } from '@dtos/Enrollment'

export function checkProgress(progress: number) {
  if (progress === 0) return 0
  if (progress > 0 && progress < 1) return progress.toFixed(2)
  return Math.floor(progress)
}

export function isCourseCompleted(enrollment?: IEnrollment | null): boolean {
  if (!enrollment || !enrollment.progressCard) return false
  return (
    enrollment.progressCard.progress >=
    enrollment.schoolProduct.certificationMinProgress
  )
}

export function shouldShowCertificate(
  enrollment?: IEnrollment | null,
): boolean {
  return (
    !!enrollment?.schoolProduct.certification && isCourseCompleted(enrollment)
  )
}

export function progressColor(progress?: number) {
  return progress === 100 ? '$progress-complete' : '$progress-fill'
}
